module.exports = __FOREMAN_VENDOR__REACT_ONCLICKOUTSIDE__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_ONCLICKOUTSIDE__"
// module id = react-onclickoutside
// module chunks = 32